<template>
  <div>
    <a-row :gutter="80" style="padding-top:30px;">
      <a-col span="8">
        <a-input-group compact>
          <a-select v-model="params.main" style="width:30%">
            <a-select-option value="name">猎头姓名</a-select-option>
            <a-select-option value="tel">手机号</a-select-option>
          </a-select>
          <a-input
            style="width:70%"
            v-model="params.mainValue"
            placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="10">
        <a-col span="7" class="form-label">地推</a-col>
        <a-auto-complete
          v-if="type === 'dev'"
          style="width:60%"
          placeholder="请输入地推查询"
          v-model="params.pm_dev_uids"
          @search="changePm"
          :dataSource="dataPm_uid"
        ></a-auto-complete>
        <a-auto-complete
          v-else
          style="width:60%"
          placeholder="请输入地推查询"
          v-model="params.pm_uids"
          @search="changePm"
          :dataSource="dataPm_uid"
        ></a-auto-complete>
      </a-col>
      <a-col>
        <a-button style="padding:0 30px;" type="primary" @click="getData()"
          >查询</a-button
        >
         <a-button style="padding:0 30px;margin-left:30px" @click="reset()"
          >重置</a-button
        >
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <time-bar ref="timebar" :time-arr="timeArr" @change="getData"></time-bar>
    <a-row type="flex" align="middle" justify="start" class="sort-bar" >
      <template v-for="sort in sorts">
        <a-col
          span="2"
          class="sort"
          :class="{ active: selectedSort.id == sort.id }"
          :key="sort.id"
          @click="changeSort(sort)"
        >
          {{ sort.name }}
          <a-icon :type="`arrow-${sort.arr}`"></a-icon>
        </a-col>
      </template>
    </a-row>
    <div class="data-table" style="padding:30px 0;">
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import TimeBar from "@/components/time-bar.component";
const sorts = [
  { name: "CV数", id: 0, value: "cv_desc", arr: "down" },
  { name: "接单职位数", id: 1, value: "job_desc", arr: "down" },
  { name: "推荐数", id: 2, value: "recommend_desc", arr: "down" },
  { name: "面试数", id: 3, value: "interview_desc", arr: "down" },
  { name: "offer数", id: 4, value: "offer_desc", arr: "down" },
  { name: "到岗数", id: 5, value: "entry_desc", arr: "down" },
  { name: "过保数", id: 6, value: "complete_desc", arr: "down" },
  { name: "面试率", id: 7, value: "interview_rate_desc", arr: "down" },
  { name: "offer率", id: 8, value: "offer_rate_desc", arr: "down" },
  { name: "到岗率", id: 9, value: "entry_rate_desc", arr: "down" },
  { name: "过保率", id: 10, value: "complete_rate_desc", arr: "down" }
]
export default {
  name: "indexTab",
  extends: baseComponentVue,
  props: ['type'],
  data() {
    return {
      loading: false,
      dataSource: [],
      columns: [],
      dataPm_uid: [],
      sorts,
      selectedSort: {},
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        main: "name",
        pm_dev_uids: '',
        pm_uids: ''
      },
      pmType: 'dev',
      pm_value:'',
      timeArr: [
         {
            key: 0,
            text: "全部",
            value: []
          },
          {
            key: 1,
            text: "昨天",
            value: [
              moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 2,
            text: "过去7天",
            value: [
              moment()
                .subtract(7, "days")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 3,
            text: "过去14天",
            value: [
              moment()
                .subtract(14, "days")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 4,
            text: "过去一月",
            value: [
              moment()
                .subtract(1, "months")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 5,
            text: "过去二月",
            value: [
              moment()
                .subtract(2, "months")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 6,
            text: "过去三月",
            value: [
              moment()
                .subtract(3, "months")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 7,
            text: "过去半年",
            value: [
              moment()
                .subtract(6, "months")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          }
      ],
    };
  },
  created() {
    if(this.type === 'dev') {
      this.params.pm_dev_uids = '';
    } else {
      this.params.pm_uids = '';
    }
    this.setColums();
  },
  mounted() {
    this.$refs.timebar.init();
  },
  components: { TimeBar },
  methods: {
    changeSort(sort) {
      console.log(sort);
      if(this.selectedSort.name&&(this.selectedSort.id===sort.id)){
        if(sort.value.indexOf("desc")>-1){
            sort.value.replace('desc', 'asc')
            this.sorts[sort.id].value=sort.value.replace('desc', 'asc')
            console.log(this.sorts[sort.id].value)
            this.sorts[sort.id].arr="up"
        }else{
            sort.value.replace('asc', 'desc')
            this.sorts[sort.id].value=sort.value.replace('asc', 'desc')
            this.sorts[sort.id].arr="down"
        }
      }
      this.selectedSort = sort;
      this.params.order = sort.value;
      this.getData();
    },
    setColums() {
      this.columns = [
        {
          title: "地推",
          dataIndex: "pm_name",
          align: "center",
        },
        {
          title: "猎头",
          dataIndex: "name",
          align: "center",
        //   width: 200,
        },
        {
          title: "CV数",
          dataIndex: "resume_count",
          align: "center"
        },
        {
          title: "接单职位数",
          dataIndex: "job_count",
          align: "center"
        },
        {
          title: "推荐数",
          dataIndex: "recommend_count",
          align: "center"
        },
        {
          title: "面试数",
          dataIndex: "interview_count",
          align: "center"
        },
        {
          title: "offer数",
          dataIndex: "offer_count",
          align: "center"
        },
        {
          title: "到岗数",
          dataIndex: "entry_count",
          align: "center"
        },
        {
          title: "过保数",
          dataIndex: "complete_count",
          align: "center"
        },
        {
          title: "面试率",
          dataIndex: "interview_rate",
          align: "center"
        },
        {
          title: "offer率",
          dataIndex: "offer_rate",
          align: "center"
        },
        {
          title: "到岗率",
          dataIndex: "entry_rate",
          align: "center"
        },
        {
          title: "过保率",
          dataIndex: "complete_rate",
          align: "center"
        }
      ];
    },
    async getData(payload) {
      this.loading = true;
      if (payload) {
        if (payload.value) {
          this.params.created_start = payload.value[0];
          this.params.created_end = payload.value[1];
          this.pagination.current = 1;
        } else {
          let pager = { ...this.pagination };
          pager.current = payload.current;
          pager.pageSize = payload.pageSize;
          this.pagination = pager;
        }
      } else {
        this.pagination.current = 1;
      }
      let params = {
        [this.params.main]: this.params.mainValue,
        created_start: this.params.created_start,
        created_end: this.params.created_end,
        page: this.pagination.current,
        limit: this.pagination.pageSize - 1,
        order: this.params.order,
        // pm_uids: this.params.pm_uids,
        // pm_dev_uids: this.params.pm_dev_uids,
      };
      console.log(this.type, this.params)
      if(this.type === 'dev') {
        params.pm_dev_uids = this.params.pm_dev_uids
        try {
          let response = await Api.hunter.getDashboardData(params);
          this.dataSource = [
            { id: -1, name: "全部", ...response.total_counts },
            ...response.list
          ];
          this.pagination.total = +response.total;
        } catch (e) {}
      } else {
        params.pm_uids = this.params.pm_uids;
        try {
          let response = await Api.hunter.getActivationData(params);
          this.dataSource = [
            { id: -1, name: "全部", ...response.total_counts },
            ...response.list
          ];
          this.pagination.total = +response.total;
        } catch (e) {}
      }
      this.loading = false;
    },
    changePm(value) {
      if (value.length >= 2) {
        Api.post.getSuggest({ name: value }).then(res => {
          const data = [];
          res.forEach(item => {
            data.push({
              text: item.name,
              value: item.uid
            });
          });
          this.dataPm_uid = data;
        });
      }
    //   if (value.length < 2) {
    //     this.params.pm_dev_uids = ''
    //   }
    },
    // selectPm(value){
    //     console.log(value)
    //     this.params.pm_dev_uids = value
    // },
    reset(){
        this.params.mainValue='';
        this.params.pm_dev_uids = '';
        this.pm_value='';
        this.selectedSort={};
        this.sorts.forEach((item)=>{
            item.arr='down';
            if(item.value.indexOf("asc")>-1){
                item.value=item.value.replace('asc', 'desc')
            }
        });
        this.getData();
    }
  }
};
</script>

<style scoped lang="scss">
.sort-bar {
  text-align: center;
  margin-top: 11px;
  border-radius: 3px;
  border: 1px solid rgba(228, 232, 235, 1);
  .sort {
    cursor: pointer;
    height: 58px;
    line-height: 58px;
    color: #909399;
    &.active {
      color: #5ec9ff;
    }
  }
}
</style>
